<script lang="ts" setup></script>

<template>
  <CoreScrollable>
    <article class="container flex flex-col mx-auto p-4 md:px-16 md:py-8">
      <slot />
    </article>
  </CoreScrollable>
</template>
